const pretendClubNames = ["Warriors Red", "Thunder FC", "Eagles United", "Lions SC",
  "Tigers AFC", "Sharks FC", "Dragons United", "Hawks SC", "Wolves AFC", "Bulls FC",
  "Knights Blue", "Dragons Green", "Tigers Yellow", "Lions Orange", "Sharks Purple",
  "Wolves Grey", "Bulls Brown", "Knights Silver", "Eagles Gold", "Hawks White",
  "Lions Trojans", "Tigers Panthers", "Sharks Dolphins", "Wolves Foxes", "Bulls Rams",
  "Knights Spartans", "Eagles Falcons", "Hawks Condors", "Dragons Wyverns", "Tigers Cougars"];

const largeTownsOfEngland = ["Reading", "Slough", "High Wycombe", "Maidenhead", "Wokingham",
  "Bracknell", "Newbury", "Basingstoke", "Aylesbury", "Milton Keynes", "Luton", "Bedford",
  "Stevenage", "Hitchin", "Welwyn", "St Albans", "Hemel Hempstead", "Watford",
  "Harlow", "Bishop's Stortford", "Chelmsford", "Colchester", "Southend-on-Sea", "Basildon",
  "Grays", "Maidstone", "Gillingham", "Chatham", "Rochester", "Sittingbourne", "Canterbury",
  "Ashford", "Folkestone", "Dover"];

const mapOfCountiesToTowns: { [key: string]: string[] } = {
  "Berkshire": ["Reading", "Slough", "Maidenhead", "Wokingham", "Bracknell", "Newbury"],
  "Buckinghamshire": ["High Wycombe", "Aylesbury", "Milton Keynes"],
  "Hampshire": ["Basingstoke"],
  "Bedfordshire": ["Luton", "Bedford"],
  "Hertfordshire": ["Stevenage", "Hitchin", "Welwyn", "St Albans", "Hemel Hempstead", "Watford", "Bishop's Stortford"],
  "Essex": ["Harlow", "Chelmsford", "Colchester", "Southend-on-Sea", "Basildon", "Grays"],
  "Kent": ["Maidstone", "Gillingham", "Chatham", "Rochester", "Sittingbourne", "Canterbury", "Ashford", "Folkestone", "Dover"]
};

const youthLeaguesByCounty: Record<string, string[]> = {
  "Berkshire": ["East Berks Football Alliance", "Berkshire Youth Development League"],
  "Buckinghamshire": ["Wycombe & South Bucks Minor Football League", "Chiltern Church Junior Football League"],
  "Hampshire": ["North East Hampshire Youth League", "Testway Youth Football League"],
  "Bedfordshire": ["Bedfordshire Youth Saturday League", "Bedfordshire Mini Soccer League"],
  "Hertfordshire": ["Herts Youth League", "West Herts Youth League"],
  "Essex": ["Colchester & District Youth Football League", "Southend & District Youth League"],
  "Kent": ["Kent Youth League", "East Kent Youth Football League"]
};

const divisionsByLeague: Record<string, string[]> = {
  "Wycombe & South Bucks Minor Football League": [
    "Division 1",
    "Division 2",
    "Division 3",
    "Division 4",
    "Division 5",
    "Division 6",
    "Division 7",
    "Division 8",
    "Division 9"
  ],
  "Kent Youth League": [
    "Premier",
    "East",
    "North",
    "South",
    "Central"
  ],
  "East Berks Football Alliance": [
    "Sections",
    "Divisions"
  ],
  "Testway Youth Football League": [
    "Division 1",
    "Division 2",
    "Division 3",
    "Development",
    "Middle",
    "Autumn"
  ],
  "Bedfordshire Youth Saturday League": [
    "Premier",
    "Division 1",
    "Division 2",
    "Division 3"
  ],
  "Bedfordshire Mini Soccer League": [
    "Mini Divisions",
    "Development Divisions"
  ],
  "Herts Youth League": [
    "Cedar",
    "Oak",
    "Sycamore",
    "Larch",
    "Alder",
    "Inter"
  ],
  "West Herts Youth League": [
    "Premier Division",
    "Division 1",
    "Division 2",
    "Division 3"
  ],
  "Colchester & District Youth Football League": [
    "A Division",
    "B Division",
    "C Division",
    "D Division",
    "E Division"
  ],
  "Southend & District Youth League": [
    "Premier",
    "Division 1",
    "Division 2"
  ],
  "Chiltern Church Junior Football League": [
    "Panthers",
    "Jaguars",
    "Pumas",
    "Cougars",
    "Youth",
    "Blue",
    "Red"
  ]
};

export const getLeaguesAndDivisions = (): Record<string, string[]> => {
  return divisionsByLeague;
}

const teamColors = ["#1976d2", "#388e3c", "#d32f2f", "#f57c00", "#7b1fa2", "#00796b", "#c2185b", "#512da8"];

const teamAgeGroups = ["U7", "U8", "U9", "U10", "U11", "U12", "U13", "U14", "U15"];

const commonEnglishSurnames = ["Smith", "Johnson", "Williams", "Brown", "Jones", "Garcia", "Miller", "Davis", "Rodriguez", "Martinez",
  "Hernandez", "Lopez", "Gonzalez", "Wilson", "Anderson", "Thomas", "Taylor", "Moore", "Jackson", "Martin",
  "Lee", "Perez", "Thompson", "White", "Harris", "Sanchez", "Clark", "Ramirez", "Lewis", "Robinson",
  "Walker", "Young", "Allen", "King", "Wright", "Scott", "Torres", "Nguyen", "Hill", "Flores",
  "Green", "Adams", "Nelson", "Baker", "Hall", "Rivera", "Campbell", "Mitchell", "Carter", "Roberts"
];

const commonEnglishAbbreviatedFirstNames = ["Al", "Ben", "Cal", "Dan", "Ed", "Fred", "Gus", "Hal", "Ian", "Jay",
  "Ken", "Lee", "Max", "Nat", "Ollie", "Pat", "Quinn", "Ray", "Sam", "Tom",
  "Ugo", "Vic", "Will", "Xan", "Yves", "Zac"
];

const commonEnglishBabyBoyFirstNames = ["Liam", "Noah", "Oliver", "Elijah", "James", "William",
  "Benjamin", "Lucas", "Henry", "Alexander", "Mason", "Michael", "Ethan", "Daniel", "Jacob",
  "Logan", "Jackson", "Levi", "Sebastian", "Mateo", "Jack", "Owen", "Theodore", "Aiden",
  "Samuel", "Joseph", "John", "David", "Wyatt", "Matthew", "Luke", "Asher",
  "Carter", "Julian", "Grayson", "Leo", "Jayden", "Gabriel", "Isaac", "Lincoln", "Anthony",
  "Hudson", "Dylan", "Ezra", "Thomas", "Charles", "Christopher", "Jaxon", "Maverick", "Josiah"
];

export const getRandomPlayerName = (currentNameSeed: string): string => {
  if (!currentNameSeed || currentNameSeed.length === 0) {
    currentNameSeed = Math.random().toString(36).substring(2, 15);
  }
  let hash = 0;
  for (let i = 0; i < currentNameSeed.length; i++) {
    hash = currentNameSeed.charCodeAt(i) + ((hash << 5) - hash);
  }
  const result = commonEnglishBabyBoyFirstNames[hash % commonEnglishBabyBoyFirstNames.length];
  if (!result || result.length === 0) {
    return commonEnglishBabyBoyFirstNames[currentNameSeed.length % commonEnglishBabyBoyFirstNames.length];
  }
  return result;
};

export const getRandomTeamColor = (idx: number): string => {
  return teamColors[idx % teamColors.length];
};

export const getRandomTeamAgeGroup = (idx: number): string => {
  return teamAgeGroups[idx % teamAgeGroups.length];
};

export const getRandomClub = (currentClubName: string | undefined, idx: number): string => {
  const parts = currentClubName?.split(' ') || [];
  const clubName = pretendClubNames[idx % pretendClubNames.length];
  const countyName = Object.entries(mapOfCountiesToTowns).find(([_, towns]) => towns.includes(parts[0]))?.[0] ?? '';
  let townName = mapOfCountiesToTowns[countyName][idx % mapOfCountiesToTowns[countyName].length] ?? largeTownsOfEngland[idx % largeTownsOfEngland.length];
  if (townName === parts[0]) townName = largeTownsOfEngland[(idx + 1) % largeTownsOfEngland.length];
  return `${townName} ${clubName} ${parts[parts.length - 1]}`;
}

export const getRandomClubName = (idx: number): {
  name: string,
  town: string,
  county: string,
  country: string,
  color: string,
  league?: string,
  division?: string,
  owner?: string,
  email?: string,
  hash?: string,
  uuid?: string,
  badge?: string,
  ageGroup: string,
  clubName: string
} => {
  const clubName = pretendClubNames[idx % pretendClubNames.length];
  const ageGroup = teamAgeGroups[idx % teamAgeGroups.length];
  const townName = largeTownsOfEngland[idx % largeTownsOfEngland.length];
  const countyName = Object.entries(mapOfCountiesToTowns).find(([_, towns]) => towns.includes(townName))?.[0] || "Unknown";
  const league = youthLeaguesByCounty[countyName][idx % youthLeaguesByCounty[countyName].length];
  const divisions = divisionsByLeague[league];
  return {
    name: `${townName} ${clubName} ${ageGroup}`,
    ageGroup,
    clubName,
    town: townName,
    county: countyName,
    country: "England",
    color: teamColors[idx % teamColors.length],
    league,
    // badge: `https://via.placeholder.com/150/${teamColors[idx % teamColors.length].substring(1)}/FFFFFF?text=${encodeURIComponent(clubName.split(' ')[0])}`,
    division: divisions && divisions.length > 0 ? divisions[idx % divisions.length] : undefined,
    owner: `${commonEnglishAbbreviatedFirstNames[idx % commonEnglishAbbreviatedFirstNames.length]} ${commonEnglishSurnames[idx % commonEnglishSurnames.length]}`,
  };
};

export const getRandomTownName = (idx: number): string => {
  return largeTownsOfEngland[idx % largeTownsOfEngland.length];
}